import React, { Fragment, useState, useContext } from "react";
import { UrlServicesContext } from "components/UrlServicesContext";
import { Navigate } from "react-router-dom";

import { makeStyles } from "@mui/styles";
import axios from "axios";
import {
  FormControl,
  Slide,
  Snackbar,
  TextField,
  Grid,
  DialogActions,
  DialogContent,
  Alert,
  Dialog,
  FormHelperText,
} from "@mui/material";
import { MailOutline, PersonOutline } from "@mui/icons-material";

import {
  cardBodyStyle,
  ButtonLoadinStyle,
  ButtonExit,
  ParagraphTextPage,
} from "components/cardBodyStyle";

const useStyles = makeStyles(cardBodyStyle);

export default function NewUserAdmin(props) {
  const classes = useStyles();

  const [openAlertSuccess, setopenAlertSuccess] = useState(false);
  const [mensaje_success, setmensaje_success] = useState("");
  const [returnLogin, setReturnLogin] = React.useState(false);
  const [error, setError] = useState(false);
  const [mensageSystem, setMensageSystem] = useState("");
  const [disable, setDisable] = useState(true);
  const [loader, setLoader] = useState(false);

  const [alert, setAlert] = React.useState({
    openAlert: false,
    errorAlert: "error",
    mensaje: "",
  });

  const { urlServices, UserAuth } = useContext(UrlServicesContext);

  let keyAuthorization = UserAuth.Session;

  const [values, setValues] = useState({
    name: "",
    lastName: "",
    document_id: "",
    email: "",
    phone: "",
    clients: "",
    errorName: false,
    errorLastName: false,
    errorEmail: false,
    errorDocument: false,
    errorPhone: false,
  });

  const handleChange = (prop, value) => {
    setValues((prevValues) => ({
      ...prevValues,
      [prop]: value,
      errorName: false,
      errorLastName: false,
      errorEmail: false,
      errorDocument: false,
      errorPhone: false,
    }));

    setAlert((prevAlert) => ({
      ...prevAlert,
      openAlert: false,
    }));

    setDisable(false);
  };

  const handleCloseDialog = (pro) => (event) => {
    props.exit();
  };

  // Expresión regular para validar el formato de correo
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  const submitForm = (e) => {
    e.preventDefault();
    setError(false);
    setopenAlertSuccess(false);

    if (values.name.length === 0) {
      setValues({ ...values, errorName: true });
      setAlert({
        ...alert,
        openAlert: true,
        errorAlert: "error",
        mensaje: "Debe agregar un nombre",
      });

      return;
    }

    if (values.lastName.length === 0) {
      setValues({ ...values, errorLastName: true });
      setAlert({
        ...alert,
        openAlert: true,
        errorAlert: "error",
        mensaje: "Debe agregar un Apellido",
      });
      return;
    }

    if (values.document_id.length === 0) {
      setValues({ ...values, errorDocument: true });
      setAlert({
        ...alert,
        openAlert: true,
        errorAlert: "error",
        mensaje: "Debe agregar un documento de identificación",
      });
      return;
    }

    if (values.email.length === 0) {
      setValues({ ...values, errorEmail: true });
      setAlert({
        ...alert,
        openAlert: true,
        errorAlert: "error",
        mensaje: "Debe agregar un correo electrónico",
      });
      return;
    }

    if (!emailRegex.test(values.email)) {
      setValues({ ...values, errorEmail: true });
      setAlert({
        ...alert,
        openAlert: true,
        errorAlert: "error",
        mensaje: `Debe ingresar un correo electrónico válido`,
      });
      return; // Salir si hay un error
    }

    if (values.phone === "") {
      setValues({ ...values, errorPhone: true });
      setAlert({
        ...alert,
        openAlert: true,
        errorAlert: "error",
        mensaje: "Debe agregar un teléfono",
      });
      return;
    }

    setLoader(true);

    const randomNumber = Math.floor(Math.random() * 900000) + 100000;

    const dataValue = {
      email: values.email.toLowerCase().trim(),
      documentId: values.document_id,
      name: values.name,
      lastName: values.lastName,
      allNames: `${values.name} ${values.lastName}`,
      profileId: 1,
      password: randomNumber.toString(),
      phone: values.phone,
    };

    axios
      .post(`${urlServices}users`, dataValue, {
        headers: {
          Authorization: "Bearer " + keyAuthorization,
        },
      })
      .then((response) => {
        setValues({
          ...values,
          name: "",
          lastName: "",
          document_id: "",
          email: "",
          phone: "",
          typeClients: null,
          typeClientsData: null,
          clients: "",
          clientsData: "",
        });

        setDisable(true);
        setopenAlertSuccess(true);
        setmensaje_success("Usuario registrado con éxito.");
        props.callBackRefresh();
        setLoader(false);
      })
      .catch((e) => {
        if (e.response.status === 409) {
          setValues({ ...values, errorEmail: true });
          setMensageSystem("Correo electrónico ya registrado.");
          setError(true);
        } else if (e.response.status === 401) {
          setMensageSystem(
            "La sesión ha expirado, vuelva a iniciar sesión ..."
          );
          setError(true);

          setTimeout(() => {
            localStorage.clear();
            setReturnLogin(true);
          }, 4000);
        } else if (e.response.status === 500) {
          setMensageSystem("Error en la consulta con sel servidor.");
          setError(true);
        }
        setLoader(false);
      });
  };

  const changeTypeClients = (data) => {
    setValues({
      ...values,
      typeClients: data !== null ? data.id : null,
      typeClientsData: data !== null ? data : null,
      clients: "",
      clientsData: "",
      errorTypeClients: false,
    });

    setAlert({
      ...alert,
      openAlert: false,
    });
  };

  const changeClients = (data) => {
    setValues({
      ...values,
      clients: data !== null ? data.id : "",
      clientsData: data !== null ? data : "",
      errorClients: false,
    });

    setAlert({
      ...alert,
      openAlert: false,
    });
  };

  const handleCloseAlert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlert({ openAlert: false });
  };

  if (returnLogin) {
    return <Navigate to="/" />;
  }

  return (
    <Fragment>
      <Dialog
        fullWidth
        onClose={handleCloseDialog(true)}
        aria-labelledby="customized-dialog-title"
        open={props.open}
        keepMounted
        scroll="body"
        PaperProps={{
          sx: {
            borderRadius: 6,
          },
        }}
      >
        <DialogContent dividers className={classes.styleDialogContent}>
          <Fragment>
            <Grid container spacing={1} className={classes.containerProfile}>
              <Grid item xs={12} sm={12}>
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={12}>
                    {error && <Alert severity="error">{mensageSystem}</Alert>}
                    <div className={classes.titleCardFilter}>Nuevo usuario</div>
                    <div className={classes.lineBottom}></div>
                    <ParagraphTextPage style={{ fontSize: 12, marginTop: 5 }}>
                      Al registrar el usuario, se le enviará al correo una clave
                      temporal para el inicio de sesión. (Revisar tanto la
                      bandeja de entrada como la del spam).
                    </ParagraphTextPage>
                  </Grid>
                  <Grid item xs={12} sm={12} sx={{ marginTop: 1 }}>
                    <b
                      className={classes.cardTitleBlack}
                      style={{ fontSize: 14, fontWeight: 500 }}
                    >
                      Usuario
                    </b>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl style={{ width: "100%" }}>
                      <TextField
                        name="name"
                        value={values.name}
                        error={values.errorName}
                        onChange={(event) =>
                          handleChange("name", event.target.value)
                        }
                        fullWidth
                        required
                        label="Nombre"
                        margin="dense"
                        autoComplete="off"
                        variant="outlined"
                        size="small"
                        InputProps={{
                          endAdornment: (
                            <PersonOutline
                              fontSize="small"
                              className={classes.iconInput}
                              position="end"
                            ></PersonOutline>
                          ),
                        }}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl style={{ width: "100%" }}>
                      <TextField
                        name="lastName"
                        value={values.lastName}
                        error={values.errorLastName}
                        onChange={(event) =>
                          handleChange("lastName", event.target.value)
                        }
                        fullWidth
                        required
                        size="small"
                        label="Apellidos"
                        margin="dense"
                        autoComplete="off"
                        variant="outlined"
                        InputProps={{
                          endAdornment: (
                            <PersonOutline
                              fontSize="small"
                              className={classes.iconInput}
                              position="end"
                            ></PersonOutline>
                          ),
                        }}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl style={{ width: "100%" }}>
                      <TextField
                        name="document_id"
                        value={values.document_id}
                        error={values.errorDocument}
                        onChange={(event) =>
                          handleChange("document_id", event.target.value)
                        }
                        fullWidth
                        required
                        size="small"
                        label="Documento"
                        margin="dense"
                        variant="outlined"
                        autoComplete="off"
                        inputProps={{
                          style: {
                            textAlign: "center",
                          },
                          maxLength: 13,
                        }}
                        onInput={(e) => {
                          e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          );
                        }}
                        helperText="Cédula, RUC o pasaporte."
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      autoComplete="off"
                      name="email"
                      value={values.email}
                      onChange={(event) =>
                        handleChange("email", event.target.value)
                      }
                      label="Email"
                      error={values.errorEmail}
                      InputProps={{
                        endAdornment: (
                          <MailOutline
                            fontSize="small"
                            className={classes.iconInput}
                            position="end"
                          ></MailOutline>
                        ),
                      }}
                      fullWidth
                      margin="dense"
                      required
                      variant="outlined"
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl style={{ width: "100%" }}>
                      <TextField
                        name="phone"
                        value={values.phone}
                        error={values.errorPhone}
                        onChange={(event) =>
                          handleChange("phone", event.target.value)
                        }
                        fullWidth
                        required
                        size="small"
                        label="Teléfono"
                        margin="dense"
                        autoComplete="off"
                        variant="outlined"
                        inputProps={{ maxLength: 14 }}
                      />
                      <FormHelperText style={{ fontSize: 11 }}>
                        Agregar el prefijo del país ejemplo: +593
                      </FormHelperText>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <br></br>
                    <center>
                      <ButtonLoadinStyle
                        type="submit"
                        onClick={submitForm}
                        disabled={disable}
                        loading={loader}
                        // loadingIndicator="Registrando…"
                        variant="outlined"
                      >
                        Crear usuario
                      </ButtonLoadinStyle>
                    </center>
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <center>
                      {openAlertSuccess && (
                        <Alert severity="success">{mensaje_success}</Alert>
                      )}
                    </center>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            {alert.openAlert && (
              <Snackbar
                open={true}
                autoHideDuration={6000}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                onClose={handleCloseAlert}
              >
                <Slide direction="up" in={true} mountOnEnter unmountOnExit>
                  <Alert
                    onClose={handleCloseAlert}
                    severity={
                      alert.errorAlert === "error" ? "error" : "success"
                    }
                    elevation={6}
                    variant="filled"
                  >
                    {alert.mensaje}
                  </Alert>
                </Slide>
              </Snackbar>
            )}
          </Fragment>
        </DialogContent>
        <DialogActions>
          <ButtonExit onClick={handleCloseDialog(true)}>Cerrar</ButtonExit>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
}
